import { Loader } from "@/components/Common/Loader/Loader";
import { MAP_RESOURCE_TYPE_TO_CLUSTER_TYPE } from "@/constants/cluster";
import { getClusterDetailsRoute, useClusterStore } from "@/store/cluster";
import { FC, useEffect, useState } from "react";
import { Redirect, useParams } from "wouter";

type RedirectStatus = "loading" | "home";

export const RedirectToClusterDetailsPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const fetchClusterDetail = useClusterStore((state) => state.fetchClusterDetail);
  const [status, setStatus] = useState<RedirectStatus>("loading");

  useEffect(() => {
    if (!id) {
      setStatus("home");
      return;
    }

    let cancelled = false;

    const resolveClusterRoute = async () => {
      try {
        const cluster = await fetchClusterDetail({
          id,
          type: undefined
        });

        if (cancelled) {
          return;
        }

        const mappedClusterType = cluster?.resourceType
          ? MAP_RESOURCE_TYPE_TO_CLUSTER_TYPE[cluster.resourceType]
          : undefined;

        if (mappedClusterType) {
          const redirectUrl = getClusterDetailsRoute({
            tool: "cloud",
            clusterType: mappedClusterType,
            clusterId: id
          });
          window.location.replace(redirectUrl);
          return;
        }

        setStatus("home");
      } catch {
        if (!cancelled) {
          setStatus("home");
        }
      }
    };

    void resolveClusterRoute();

    return () => {
      cancelled = true;
    };
  }, [id, fetchClusterDetail]);

  if (!id || status === "home") {
    return <Redirect to="/cloud/home" />;
  }

  return <Loader color="#ffffff" className="h-[40px] w-[40px]" />;
};
